export const column = [
  { key: '1', headerName: 'S.No', field: 'S.No', hide: false, width: 150 },
  // { key: '2', headerName: 'Designation ID', field: 'id', hide: false, width: 250 },
  { key: '3', headerName: 'Designation', field: 'name', hide: false, width: 300 },
  { key: '4', headerName: 'Status', field: 'status', hide: false, width: 600 },
];
